/* eslint-disable indent,no-new,no-undef,no-unused-expressions, no-useless-escape */
export default {
  data () {
    return {
      trustIndexOverTimeRows: [],
      trustIndexOverTimeColumns: [],
      trustIndexOverTimeOptions: {
        title: '',
        legend: 'none',
        vAxis: {
          title: '',
          textStyle: {
            color: '#7b7c7e',
            bold: true
          },
          viewWindow: { max: 10 },
          viewWindowMode: 'explicit'
        },
        hAxis: {
          title: '',
          textStyle: {
            color: '#7b7c7e'
          }
        },
        height: 450,
        pointSize: 10,
        series: {
          0: {
            type: 'line',
            color: '#30AAE1'
          }
        },
        chartArea: {
          'width': '90%',
          'height': '80%',
          top: '9%',
          bottom: '50%',
          left: '10%'
        }
      },
      reviewsOverTimeRows: [],
      reviewsOverTimeColumns: [],
      reviewsOverTimeOptions: {
        title: '',
        legend: 'none',
        vAxis: {
          title: '',
          textStyle: {
            color: '#7b7c7e',
            bold: true
          }
        },
        hAxis: {
          title: '',
          slantedText: true,
          slantedTextAngle: 90,
          textStyle: {
            color: '#7b7c7e'
          }
        },
        height: 450,
        pointSize: 10,
        series: {
          0: {
            type: 'bars',
            color: '#30AAE1'
          },
          1: {
            type: 'line',
            color: '#267BA4'
          }
        },
        chartArea: {
          'width': '90%',
          'height': '80%',
          top: '9%',
          bottom: '20%'
        }
      },
      reviewAnalyticsOptions: {
        title: '',
        legend: 'none',
        backgroundColor: {
          fill: '#fafafa'
        },
        vAxis: {
          title: '',
          format: '0',
          scaleType: 'linear',
          textStyle: {
            bold: false,
            fontSize: 13,
            color: '#58595b'
          },
          minorGridlines: {
            color: 'none'
          },
          baselineColor: '#cccccc'
        },
        hAxis: {
          title: '',
          slantedText: false,
          slantedTextAngle: 90,
          allowContainerBoundaryTextCutoff: false,
          textStyle: {
            color: '#58595b',
            fontSize: 13
          }
        },
        height: 366,
        pointSize: 10,
        series: {
          0: {
            type: 'bars',
            color: '#1d7299'
          },
          1: {
            type: 'line',
            color: '#267BA4'
          }
        },
        chartArea: {
          top: '5%',
          left: '4%',
          width: '94.5%',
          height: '80%',
          bottom: '8%'
        },
        animation: {
          duration: 300,
          easing: 'out',
          startup: true
        }
      },
      analyticsTrustIndexOptions: {
        title: '',
        legend: 'none',
        vAxis: {
          title: '',
          textStyle: {
            color: '#7b7c7e',
            bold: true
          },
          viewWindow: { max: 10 },
          viewWindowMode: 'explicit'
        },
        hAxis: {
          title: '',
          textStyle: {
            color: '#7b7c7e'
          }
        },
        height: 450,
        pointSize: 10,
        series: {
          0: {
            type: 'line',
            color: '#30AAE1'
          }
        },
        chartArea: {
          top: '5%',
          left: '4%',
          width: '94.5%',
          height: '80%',
          bottom: '25%'
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/graphs.js